export const showOtpInAddCustomer = false;
export const recovery_insurance_category_type="3"